import { getAppConfig } from '../config/runtimeConfig';

const ADMIN_USER_FIELDS = `
  username
  subInternal
  email
  enabled
  status
  createdAt
  updatedAt
  groups
  role
  roleError
`;

async function graphqlRequest(query, variables, idToken) {
  const appsyncUrl = getAppConfig('REACT_APP_ADMIN_APPSYNC_URL').replace(/\/+$/, '');
  if (!idToken) {
    throw new Error('Missing ID token. Please sign in again.');
  }
  if (!appsyncUrl) {
    throw new Error('REACT_APP_ADMIN_APPSYNC_URL is not configured.');
  }

  const response = await fetch(appsyncUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: idToken,
    },
    body: JSON.stringify({ query, variables }),
  });

  const result = await response.json().catch(() => ({}));

  if (result.errors && result.errors.length > 0) {
    const firstError = result.errors[0];
    throw new Error(firstError.message || 'Admin API request failed.');
  }

  return result.data;
}

export function listAdminUsers(idToken) {
  const query = `query ListAdminUsers {
    listAdminUsers {
      users { ${ADMIN_USER_FIELDS} }
      roles
    }
  }`;
  return graphqlRequest(query, {}, idToken).then((data) => data.listAdminUsers);
}

export function createAdminUser(idToken, { email, role }) {
  const query = `mutation CreateAdminUser($email: AWSEmail!, $role: String!) {
    createAdminUser(email: $email, role: $role) {
      user { ${ADMIN_USER_FIELDS} }
    }
  }`;
  return graphqlRequest(query, { email, role }, idToken).then((data) => data.createAdminUser);
}

export function updateAdminUserRole(idToken, username, role) {
  const query = `mutation UpdateAdminUserRole($username: String!, $role: String!) {
    updateAdminUserRole(username: $username, role: $role) {
      user { ${ADMIN_USER_FIELDS} }
    }
  }`;
  return graphqlRequest(query, { username, role }, idToken).then((data) => data.updateAdminUserRole);
}

export function deleteAdminUser(idToken, username) {
  const query = `mutation DeleteAdminUser($username: String!) {
    deleteAdminUser(username: $username)
  }`;
  return graphqlRequest(query, { username }, idToken);
}
